import * as React from "react";
import { Clock, Activity, Database, Globe } from "lucide-react";

import { Card } from "../../../components/ui-v2/card";
import { Text, Label, MonoText } from "../../../components/ui-v2/typography";
import { WINDOW_OPTIONS, formatUptime } from "./constants";

function StatCard({ title, value, icon: Icon, subtitle }) {
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <Label className="text-xs">{title}</Label>
          <MonoText size="xl" weight="bold" className="block mt-1">
            {value}
          </MonoText>
          {subtitle && (
            <Text variant="secondary" size="xs" className="mt-0.5">
              {subtitle}
            </Text>
          )}
        </div>
        {Icon && (
          <div className="rounded-md bg-primary/10 p-2 ml-2">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        )}
      </div>
    </Card>
  );
}

export function SystemOverview({
  loading,
  uptimeMinutes,
  totalRequests,
  totalApiCalls,
  totalDynamoOps,
  windowMinutes,
}) {
  const windowLabel =
    WINDOW_OPTIONS.find((o) => o.value === windowMinutes)?.label ||
    `${windowMinutes}m`;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <StatCard
        title="Uptime"
        value={loading ? "-" : formatUptime(uptimeMinutes)}
        icon={Clock}
        subtitle="Since last restart"
      />
      <StatCard
        title="Total Requests"
        value={loading ? "-" : totalRequests.toLocaleString()}
        icon={Activity}
        subtitle={`In last ${windowLabel}`}
      />
      <StatCard
        title="API Calls"
        value={loading ? "-" : totalApiCalls.toLocaleString()}
        icon={Globe}
        subtitle="Finnhub + Yahoo Finance"
      />
      <StatCard
        title="DynamoDB Ops"
        value={loading ? "-" : totalDynamoOps.toLocaleString()}
        icon={Database}
        subtitle="Total operations"
      />
    </div>
  );
}

export default SystemOverview;
